import { render } from "./CreateContacts.vue?vue&type=template&id=2b5c07e6"
import script from "./CreateContacts.vue?vue&type=script&lang=js"
export * from "./CreateContacts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__